import React from 'react';
import QuestionForm, { FormData } from '../molecules/QuestionForm';
import { useLetterStore } from '../../store/letterStore';
import { useNavigate } from 'react-router-dom';

const Question: React.FC = () => {
  const navigate = useNavigate();
  const { letterData, createLetterData, setLetterData } = useLetterStore();

  const onSubmit = (data: FormData) => {
    const formData = {
      to_name: data.toName,
      from_name: data.fromName,
      date: data.date,
      end_date: data.endDate,
    };

    // letterDataが既に存在する場合は更新、そうでない場合は新規作成
    if (letterData) {
      setLetterData(formData);
    } else {
      createLetterData(formData);
    }

    navigate('/message');
  };

  // letterDataがnullの場合は空のオブジェクトを渡す
  const defaultValues: FormData = letterData
    ? {
        toName: letterData.to_name || '',
        fromName: letterData.from_name || '',
        date: letterData.date || new Date().toISOString().split('T')[0],
        endDate: letterData.end_date || '',
      }
    : {
        toName: '',
        fromName: '',
        date: new Date().toISOString().split('T')[0],
        endDate: '',
      };

  return <QuestionForm defaultValues={defaultValues} onSubmit={onSubmit} />;
};

export default Question;
